import { Button, Search } from '@ibsys/kit';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useHasPermission } from '@/entities/profile';
import { useFormGuardActions } from '@/entities/formGuard';
import { AttributeGroupsList } from './ui/AttributeGroupsList';
import { AttributeGroupCard } from './ui/AttributeGroupCard';
import { MasterDetailLayout } from '@/shared/ui';

export const AttributeGroupsPage: FC = () => {
  const { t } = useTranslation(['common', 'attributeGroups']);
  const navigate = useNavigate();
  const { id } = useParams<{ id?: string }>();
  const hasDevelopment = useHasPermission('DEVELOPMENT');
  const allowAdmin = useHasPermission('ADMIN_ATTRIBUTE_GROUP');
  const { setIsDirty } = useFormGuardActions();

  const [search, setSearch] = useState('');

  const handleCreate = () => {
    navigate('/attribute-groups/create');
  };

  const handleBack = () => {
    navigate('/attribute-groups');
  };

  return (
    <MasterDetailLayout
      isDetailOpen={Boolean(id)}
      onBack={handleBack}
      toolbar={
        <div className="flex items-center gap-4">
          {hasDevelopment && (
            <>
              <Search
                className="flex-1"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder={t('common:search')}
              />
              <Button variant="outline">{t('common:search')}</Button>
            </>
          )}
          {allowAdmin && (
            <Button onClick={handleCreate} className="ml-auto">
              {t('attributeGroups:addGroup')}
            </Button>
          )}
        </div>
      }
      list={<AttributeGroupsList />}
      detail={<AttributeGroupCard entityId={id} key={id} onUnsavedChange={(dirty) => setIsDirty(dirty)} />}
    />
  );
};
